/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Freight_CostInputs */

const en_field_freight_cost = /** @type {(inputs: Field_Freight_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freight`)
};

/**
* | output |
* | --- |
* | "Freight" |
*
* @param {Field_Freight_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_freight_cost = /** @type {((inputs?: Field_Freight_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Freight_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_freight_cost(inputs)
});